import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { trackEvent } from "../../services/GoogleAnalytics";
import HomeStoryDetailView from "../browse-stories/HomeStoryDetailView";
import { useHomeStoryDetail } from "../browse-stories/useHomeStoryDetail";
import { usePagesTranslation } from "../locales";

/** Full-page Puzzle of the Day (`/puzzle-of-day`) or featured (`/puzzle-of-day/:storyId`). */
export default function PuzzleOfDayPage() {
    const { storyId } = useParams();
    const { t } = usePagesTranslation();
    const featuredStoryId =
        typeof storyId === "string" && storyId.trim() !== "" ? storyId.trim() : undefined;

    const { row, loading, detailLoading, error, contentLanguage } =
        useHomeStoryDetail(featuredStoryId);

    useEffect(() => {
        trackEvent("entered", {
            name: "PuzzleOfDayPage",
            page_type: "PUZZLE_OF_DAY",
            story_id: featuredStoryId ?? undefined,
        });
    }, [featuredStoryId]);

    return (
        <Box sx={{ p: { xs: 1.5, sm: 2 }, maxWidth: 1400, mx: "auto" }}>
            <HomeStoryDetailView
                row={row}
                loading={loading}
                detailLoading={detailLoading}
                error={error}
                contentLanguage={contentLanguage}
                pageTitle={featuredStoryId ? undefined : t("landing.puzzle-of-day-title")}
            />
        </Box>
    );
}
